






















import { Component, Vue, Inject } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
@Component({
    components: {}
})
export default class UserLayout extends AbpBase {
    mounted () {
        document.body.classList.add('userLayout')
    }
    beforeDestroy () {
        document.body.classList.remove('userLayout')
    }
}
